'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LKIcon } from '../icon/module';
import {BubbleComponent} from "./component";

@NgModule({
  imports     : [
    BrowserModule,
    LKIcon,
  ],
  declarations: [BubbleComponent],
  exports     : [BubbleComponent]
})
export class LKBubble {
}
